import axios, { AxiosProgressEvent } from 'axios';

interface UploadFileParams {
  url: string;
  file: File | ReadableStream;
  signal?: AbortSignal;
  onUploadProgress?: (progress: AxiosProgressEvent) => void;
  fileSize: number;
}

// S E R V I C E

export const uploadFileService = (params: UploadFileParams) => {
  const { url, file, onUploadProgress, fileSize } = params;
  return axios.put(url, file, {
    onUploadProgress,
    headers: { 'x-amz-storage-class': 'INTELLIGENT_TIERING', 'x-amz-content-length': fileSize },
    signal: params.signal,
  });
};

export class DownloadHttpError extends Error {
  readonly status: number;

  constructor(status: number) {
    super(`Download failed with status ${status}`);
    this.name = 'DownloadHttpError';
    this.status = status;
  }
}

/** Fetch with cache: 'no-store' — XHR/axios hits a bad browser cache after FC player Range/206 on the same signed URL. */
export const downloadFile = async (url: Url, cb: (progress: number) => void) => {
  const response = await fetch(url, { cache: 'no-store' });
  if (!response.ok) {
    throw new DownloadHttpError(response.status);
  }

  const total = Number(response.headers.get('Content-Length')) || 0;
  const reader = response.body?.getReader();
  if (!reader) {
    const data = await response.blob();
    cb(1);
    return { data };
  }

  const chunks: BlobPart[] = [];
  let received = 0;
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    if (!value) continue;
    chunks.push(value);
    received += value.byteLength;
    if (total > 0) cb(received / total);
  }

  cb(1);
  const data = new Blob(chunks, { type: response.headers.get('Content-Type') ?? undefined });
  return { data };
};
